import api from "./api.js";

export default class AlarmApi {
  static async create(data) {
    return await api.post(`alarm`, data);
  }
  static async getList(params) {
    return await api.get(`alarm`, params);
  }
  static async getById(alarmId, params) {
    return await api.get(`alarm/${alarmId}`, params);
  }
  static async update(alarmId, data) {
    return await api.put(`alarm/${alarmId}`, data);
  }
  static async delete(data) {
    return await api.del(`alarm`, data);
  }
}
